import React from 'react';
import { shape } from 'prop-types';
import styled from 'styled-components';
import { Box, Button, Heading, Text } from '@freska/freska-ui';
import { theme } from '@freska/freska-ui';
import { useHistory } from 'react-router';

import logout from '../../utils/logout';
import { withApollo } from 'react-apollo';

const svgAlert = (
  <svg width="89" height="76" viewBox="0 0 89 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="12.5" y="12" width="64" height="64" rx="12" fill="#B3E3F2" />
    <path d="M28.5 39.9997L25.8334 41.333V57.333L33.8334 65.333H43.1667L56.5 57.333L65.8334 45.333L63.1667 38.6663L53.8334 46.6663H51.1667V22.6663L44.5 21.333V34.6663H40.5L37.8334 37.333H32.5L31.1667 39.9997H28.5Z" fill="#E9F5F9" />
    <path fillRule="evenodd" clipRule="evenodd" d="M46.8 19.9998C44.7381 19.9998 43.0667 21.6712 43.0667 23.7331V32.7641C42.8924 32.7392 42.7143 32.7263 42.5332 32.7263H40.4343C38.8618 32.7263 37.5164 33.6985 36.9663 35.0745C36.7087 35.0183 36.4412 34.9887 36.1668 34.9887H34.0678C32.2025 34.9887 30.6567 36.3566 30.3789 38.144C30.1908 38.1148 29.998 38.0997 29.8017 38.0997H27.7027C25.6409 38.0997 23.9694 39.7712 23.9694 41.833V44.3424C23.9691 44.5058 23.9686 44.6723 23.9681 44.8418C23.958 48.2421 23.9443 52.8455 25.0628 57.0018C26.3058 61.6209 29.0279 65.9623 34.8361 67.545C38.4164 68.5206 42.1213 67.8348 45.5791 66.3681C49.04 64.9 52.383 62.5967 55.3378 60.1323C61.2374 55.2119 65.8351 49.4402 67.0293 47.6621C67.8362 46.4606 68.0637 45.0474 67.979 43.7615C67.8941 42.4723 67.4909 41.1935 66.8902 40.1378C66.3083 39.1152 65.4279 38.1098 64.2617 37.6541C63.6515 37.4157 62.961 37.3305 62.2485 37.4977C61.5409 37.6637 60.9232 38.0522 60.406 38.5807C59.7401 39.2612 59.1253 40.031 58.5521 40.7573L58.3997 40.9506C57.8666 41.6269 57.3596 42.2701 56.8125 42.8764C55.6278 44.1896 54.3879 45.1747 52.7644 45.5788C52.7609 45.5762 52.7565 45.5725 52.7513 45.5677C52.6997 45.5197 52.6323 45.406 52.6323 45.2484V23.7331C52.6323 21.6712 50.9608 19.9998 48.899 19.9998H46.8ZM27.1694 44.4155C27.1697 44.2559 27.1699 44.098 27.1699 43.9419L27.1694 41.833C27.1694 41.5385 27.4082 41.2997 27.7027 41.2997H29.8017C30.088 41.2997 30.3216 41.5252 30.3345 41.8083V46.0754C30.3216 46.3585 30.088 46.584 29.8017 46.584H27.7027C27.4082 46.584 27.1694 46.3453 27.1694 46.0507V44.4155ZM27.247 49.7565C27.3533 51.9022 27.5977 54.1073 28.1529 56.1702C29.2163 60.1219 31.3376 63.275 35.6773 64.4575C38.3242 65.1788 41.2597 64.7242 44.3294 63.4221C47.3959 62.1214 50.4674 60.0275 53.2882 57.6749C58.9395 52.9615 63.3367 47.4207 64.3728 45.878C64.681 45.4191 64.8381 44.7648 64.7859 43.9718C64.7339 43.1821 64.4789 42.3706 64.1089 41.7203C63.72 41.037 63.3173 40.7207 63.0972 40.6347C63.0176 40.6036 62.9881 40.6109 62.9804 40.6129C62.9693 40.6155 62.8677 40.6404 62.6931 40.8189C62.1623 41.3612 61.645 42.0035 61.0641 42.7397L60.9062 42.9399C60.3838 43.6031 59.811 44.33 59.1885 45.02C57.8042 46.5543 56.0404 48.0623 53.533 48.6852C51.101 49.2893 49.4323 47.1586 49.4323 45.2484V23.7331C49.4323 23.4385 49.1935 23.1998 48.899 23.1998H46.8C46.5054 23.1998 46.2667 23.4385 46.2667 23.7331L46.2666 48.8789C46.2666 50.9407 44.5951 52.6122 42.5332 52.6122H40.4343C39.1612 52.6122 38.037 51.975 37.3631 51.0022C36.9876 51.1292 36.5852 51.198 36.1668 51.198H34.0678C32.795 51.198 31.671 50.5611 30.9971 49.5886C30.6218 49.7153 30.2198 49.784 29.8017 49.784H27.7027C27.5484 49.784 27.3963 49.7747 27.247 49.7565ZM40.4343 35.9263C40.1397 35.9263 39.9009 36.1651 39.9009 36.4597V48.8789C39.9009 49.1734 40.1397 49.4122 40.4343 49.4122H42.5332C42.8278 49.4122 43.0666 49.1734 43.0666 48.8789V36.4597C43.0666 36.1651 42.8278 35.9263 42.5332 35.9263H40.4343ZM33.5345 46.1161V47.4647C33.5345 47.7592 33.7733 47.998 34.0678 47.998H36.1668C36.4613 47.998 36.7001 47.7592 36.7001 47.4647V38.722C36.7001 38.4275 36.4613 38.1887 36.1668 38.1887H34.0678C33.7733 38.1887 33.5345 38.4275 33.5345 38.722V41.7676L33.535 41.833V46.0507L33.5345 46.1161Z" fill="black" />
    <path d="M3.5 35L14.5 33" stroke="#64B6CF" strokeWidth="3.2" />
    <path d="M6.5 17L15.5 19" stroke="#64B6CF" strokeWidth="3.2" />
    <path d="M40.5 0V8" stroke="#64B6CF" strokeWidth="3.2" />
    <path d="M21.5 2L25 11" stroke="#64B6CF" strokeWidth="3.2" />
    <rect x="64.5" width="24" height="24" rx="12" fill="#EE4948" />
    <circle cx="76.5" cy="17.5" r="2" transform="rotate(-180 76.5 17.5)" fill="white" />
    <rect x="78" y="14" width="3" height="10" transform="rotate(-180 78 14)" fill="white" />
  </svg>
);

const propTypes = {
  client: shape({}).isRequired,
};

const AppClosed = ({ client }) => {
  const history = useHistory();
  return (
    <Wrapper>
      <LogoutButton onClick={() => logout({ history, client })}>Logout</LogoutButton>
      <ContentWrapper>
        {svgAlert}
        <Heading color="white" level={3} mt={3}>Superheroes Web is permanently closed</Heading>
        <Text color="white" mt={2}>Please use the Freska Pro app from now on to gain access to the new features we are building for you. <span role="img" aria-label="smile">😊</span></Text>
        <Box display="flex" flexDirection="column" mt={4}>
          <Button variant="secondary" href="https://freskaworker.page.link/banner">Open Freska Pro</Button>
        </Box>
      </ContentWrapper>
      <StyledButton href="https://forms.gle/HsKDXkrvDUq9m9WR7" target="_blank" mb={2}>Give us feedback</StyledButton>
    </Wrapper>
  );
};

const Wrapper = styled(Box)`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #1A237E;
  color: ${theme.colors.white};
`;

const LogoutButton = styled(Button)`
  background-color: #1A237E !important;
  color: white !important;
  align-self: end;
`;

const StyledButton = styled(Button)`
  background-color: #1A237E !important;
  color: white !important;
`;

const ContentWrapper = styled.div`
  padding: 0 ${theme.space[3]}px;
  text-align: center;
  @media (min-width: 600px) {
    padding: 0 ${theme.space[6]}px;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-grow: 1;
`;

AppClosed.propTypes = propTypes;

export default withApollo(AppClosed);
